import React from "react";
import { branch } from "baobab-react/higher-order";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Flexbox from "flexbox-react";
import { DropdownButton, MenuItem } from "react-bootstrap";

import MultiSelectToolbar from "./app-multiselect-toolbar";

import { selectAllStatusItems, resetSelectedStatusItems } from "../../actions/statusActions";
import { getOrgId } from "../../actions/orgsActions";
import { isOrganizationAdministrator, isOrganizationEmployeeInternal, isOrganizationUser } from "../../actions/user";

const JAB_CC_ORG_ID = "332a9d47-6e36-11e8-a392-061714f61e3e";

class MultiSelectStatusToolbar extends React.PureComponent {
	render() {
		const orgId = getOrgId();
		const isAdmin = isOrganizationAdministrator();
		const isJabCcInternalUser = orgId === JAB_CC_ORG_ID && isOrganizationUser() && isOrganizationEmployeeInternal();
		const canBulkWorkflow = orgId === JAB_CC_ORG_ID && (isAdmin || isJabCcInternalUser);
		const canBulkPrint = isAdmin;
		const canPrintInvoices = isAdmin && orgId === JAB_CC_ORG_ID;
		const canBulkDelete = isAdmin;
		const printButtonStyle = {
			background: "transparent",
			border: "none",
			color: "white",
			fontSize: "18px",
			fontWeight: 700,
			padding: "0 10px"
		};

		let multiSelectToolbar =
			<MultiSelectToolbar
				selectedItems={this.props.selectedStatusItems}
				showSelectAll={isAdmin}
				onClickClose={() => {
					this.props.dispatch(
						resetSelectedStatusItems
					);
				}}
				onClickSelectAll={() => {
					this.props.dispatch(
						selectAllStatusItems
					);
				}}>
				<Flexbox flexDirection="row" alignItems="center">
					{canBulkPrint &&
						<div style={{ marginRight: "18px" }}>
							<DropdownButton
								id="selected-status-print-menu"
								title={<span><FontAwesomeIcon icon="print" /> <span style={{ fontSize: "15px" }}>Print</span></span>}
								bsStyle="link"
								pullRight
								style={printButtonStyle}
							>
								{canPrintInvoices &&
									<MenuItem eventKey="invoice" onClick={(e) => {
										e.stopPropagation();
										if (window.globalSearchHistoryView) {
											window.globalSearchHistoryView.openInvoiceReportModal();
										}
									}}>
										<FontAwesomeIcon icon="file-invoice-dollar" /> Print Invoices Report
									</MenuItem>
								}
								<MenuItem eventKey="activity" onClick={(e) => {
									e.stopPropagation();
									if (window.globalSearchHistoryView) {
										window.globalSearchHistoryView.printSelectedActivityReport();
									}
								}}>
									<FontAwesomeIcon icon="print" /> Print Activities Report
								</MenuItem>
								<MenuItem eventKey="completion" onClick={(e) => {
									e.stopPropagation();
									if (window.globalSearchHistoryView) {
										window.globalSearchHistoryView.printSelectedCompletionReport();
									}
								}}>
									<FontAwesomeIcon icon="check-square" /> Print Completion Report
								</MenuItem>
							</DropdownButton>
						</div>
					}
					{canBulkWorkflow &&
						<div style={{ marginRight: "25px", cursor: "pointer" }} onClick={() => {
							window.globalSearchHistoryView.setWorkflowStatuses();
						}}>
							<FontAwesomeIcon icon="users-cog" />
						</div>
					}
					{canBulkDelete &&
						<div style={{ cursor: "pointer" }} onClick={() => {
							window.globalSearchHistoryView.deleteInstances();
						}}>
							<FontAwesomeIcon icon="trash" />
						</div>
					}
				</Flexbox>
			</MultiSelectToolbar>;

		if (this.props.selectedStatusItems.length === 0) {
			multiSelectToolbar = null;
		}

		return multiSelectToolbar;
	}
}

export default branch({
	selectedStatusItems: ["appState", "selectedStatusItems"],
}, MultiSelectStatusToolbar);
